// Types
export const TYPE_TEXT = 1
export const TYPE_VOICE = 2

// Tiers
export const TIER_BASIC = 1
export const TIER_PREMIUM = 2
export const TIER_ULTRA_PREMIUM = 3

// Tier Labels
export const TIER_LABEL_BASIC = 'Basic'
export const TIER_LABEL_PREMIUM = 'Premium'
export const TIER_LABEL_ULTRA_PREMIUM = 'Ultra Premium'

// Directions
export const DIRECTION_INBOUND = 1
export const DIRECTION_OUTBOUND = 2

// Models
export const MODEL_GPT_35_T = 1
export const MODEL_GPT_35_T_1106 = 2
export const MODEL_GPT_4_1106_PREVIEW = 3
export const MODEL_GPT_4 = 4
export const MODEL_GPT_4_T = 5
export const MODEL_GPT_4O = 6
export const MODEL_GPT_4O_MINI = 7
export const MODEL_GPT_41 = 8
export const MODEL_GPT_41_MINI = 9
export const MODEL_GPT_41_NANO = 10
export const MODEL_GPT_5 = 11
export const MODEL_GPT_5_MINI = 12
export const MODEL_GPT_5_NANO = 13
export const MODEL_GPT_51 = 14
export const MODEL_GPT_52 = 15
export const MODEL_GPT_54 = 16
export const MODEL_GPT_54_MINI = 17
export const MODEL_GPT_54_NANO = 18

// Voice Models
export const VOICE_MODEL_GPT_REALTIME_15 = 19
export const VOICE_MODEL_GPT_REALTIME_MINI = 18
export const VOICE_MODEL_GPT_4O = 3
export const VOICE_MODEL_GPT_4O_MINI = 4
export const VOICE_MODEL_CLAUDE_35_SONNET = 5 // Deprecated
export const VOICE_MODEL_CLAUDE_3_HAIKU = 6 // Deprecated
export const VOICE_MODEL_CLAUDE_35_HAIKU = 7
export const VOICE_MODEL_CLAUDE_37_SONNET = 8
export const VOICE_MODEL_GEMINI_20_FLASH = 9
export const VOICE_MODEL_GEMINI_20_FLASH_LITE = 10
export const VOICE_MODEL_GPT_41 = 11
export const VOICE_MODEL_GPT_41_MINI = 12
export const VOICE_MODEL_GPT_41_NANO = 13

// Providers
export const PROVIDER_OPENAI = 'openai'
export const PROVIDER_ELEVENLABS = 'elevenlabs'
export const PROVIDER_DEEPGRAM = 'deepgram'
export const PROVIDER_ANTHROPIC = 'anthropic'
export const PROVIDER_GOOGLE = 'google'

// Follow-Up Units
export const UNIT_MINUTES = 1
export const UNIT_HOURS = 2
export const UNIT_DAYS = 3

// Languages
export const LANGUAGE_EN_US = 'en-US'
export const LANGUAGE_EN_GB = 'en-GB'

export const DEFAULT_11LABS_VOICE_ID = '11labs-Adrian'
export const DEFAULT_OPENAI_VOICE_ID = 'openai-Alloy'

export const UNSUPPORTED_S2S_VOICES = [
    'openai-Fable',
    'openai-Nova',
    'openai-Onyx'
]

// Labels
export const LABEL_ANTHROPIC = 'Anthropic'
export const LABEL_GOOGLE = 'Google'
export const LABEL_OPENAI = 'OpenAI'
export const LABEL_OPENAI_REALTIME = 'OpenAI Realtime'
export const LABEL_DEEPGRAM = 'Deepgram'
export const LABEL_ELEVENLABS = 'ElevenLabs'

// Groups
export const GROUP_OPENAI_REALTIME = 'openai-realtime'

// Internal Types
export const INTERNAL_TYPE_MISSED_CALL_HANDLER = 'aloai_missed_call_handler'
export const INTERNAL_TYPE_IVA = 'aloai_iva'

// Internal types that cannot be deleted
export const NON_DELETABLE_INTERNAL_TYPES = [
    INTERNAL_TYPE_MISSED_CALL_HANDLER
]

// Internal types that cannot be toggled (enabled/disabled)
export const NON_TOGGLEABLE_INTERNAL_TYPES = [
    INTERNAL_TYPE_MISSED_CALL_HANDLER
]

// Tool Types
export const TOOL_UPDATE_CONTACT = 'update_contact'
export const TOOL_TRANSFER_CALL = 'transfer_call'
export const TOOL_SEND_SMS = 'send_sms'
export const TOOL_MANAGE_APPOINTMENT = 'manage_appointment'
export const TOOL_ADD_DISPOSITION = 'add_disposition_status'
export const TOOL_ADD_CALL_DISPOSITION = 'add_call_disposition_status'
export const TOOL_ADD_TAGS = 'add_tags'
export const TOOL_ADD_COMMUNICATION_TAGS = 'add_communication_tags'
export const TOOL_DISENGAGE_CONTACT = 'disengage_contact'
export const TOOL_ADD_LISTS = 'add_lists'
export const TOOL_CUSTOM_FUNCTION = 'custom_function'
export const TOOL_SET_CONTACT_DNC = 'set_contact_dnc'
export const TOOL_LEAVE_VOICEMAIL = 'leave_voicemail'
export const TOOL_SUMMARIZE_CONVERSATION_AS_NOTE = 'summarize_conversation_as_note'
export const TOOL_ENROLL_TO_SEQUENCE = 'enroll_to_sequence'
export const TOOL_ROUTE_TO_HS_DEAL_CONTACT_OWNER = 'route_to_hs_deal_contact_owner'
export const TOOL_CREATE_HUBSPOT_TICKET = 'create_hubspot_ticket'
export const TOOL_ROUTE_TO_EXTENSION = 'route_to_extension'
export const TOOL_EXECUTE_SMS_SEQUENCE = 'execute_sms_sequence'

// Post-Call Notification Modes
export const POST_CALL_NOTIFICATION_MODE_DEFAULT = 1
export const POST_CALL_NOTIFICATION_MODE_ALL_USERS = 2
export const POST_CALL_NOTIFICATION_MODE_CONTACT_OWNER = 3
export const POST_CALL_NOTIFICATION_MODE_SPECIFIC_USERS = 4

// Instruction Templates
export const INSTRUCTION_TEMPLATES = [
    {
        id: 1,
        name: 'Customer Support Agent',
        description: 'A customer support agent that handles inquiries and resolves issues.',
        content: 'You are a helpful customer support agent for our company. Your role is to provide accurate information and help customers resolve their issues efficiently.\n\nPersonality traits:\n- Friendly and approachable\n- Patient and empathetic\n- Professional and knowledgeable\n- Solution-oriented\n\nKey responsibilities:\n1. Understand customer issues and needs\n2. Provide relevant information and solutions\n3. Use tools to help resolve issues and categorize interactions\n4. Maintain a positive tone throughout interactions\n5. Follow up appropriately with unresolved issues\n\nWhen interacting with customers:\n- If a customer has a specific issue, you can {Add ( 12501: Support Handled ) disposition to the contact} to update the status of the interaction\n- For tracking conversation topics, use {Add [ customer-service ] tag(s) to the contact} to categorize the conversation\n- If a customer needs follow-up, add them to an appropriate list using {Add contact to [ follow-up ] list(s)}\n- When you cannot resolve an issue directly, use {Transfer to this line: Customer Support Team|123} to connect them with a specialist\n\nIf you don\'t know an answer, be honest and offer to connect them with someone who can help. Ask clarifying questions when needed to better understand their problem.'
    },
    {
        id: 2,
        name: 'Sales Representative',
        description: 'A sales agent focused on product information and conversions.',
        content: 'You are a knowledgeable sales representative for our company. Your goal is to understand customer needs, provide relevant product information, and help them make informed purchasing decisions.\n\nPersonality traits:\n- Persuasive but not pushy\n- Enthusiastic about our products/services\n- Attentive to customer needs\n- Confident and knowledgeable\n\nKey responsibilities:\n1. Identify customer needs through thoughtful questions\n2. Present relevant products/services and their benefits\n3. Address objections professionally\n4. Guide customers through the decision-making process\n5. Close sales appropriately\n\nWhen engaging with potential customers:\n- After understanding their needs, use {Add [ product-interest ] tag(s) to the contact} to categorize their interests for future reference\n- When qualifying a lead, use {Add ( 12502: Sales Qualified ) disposition to the contact} to mark their level of interest\n- For leads that require nurturing, add them to our follow-up sequence with {Add contact to [ sales-nurture ] list(s)}\n- If a lead shows high intent to purchase, you can {Transfer to this line: Sales Closer|456} to connect them with a closer\n\nWork to understand what the customer is looking for by asking relevant questions about their needs, budget, and timeline. Recommend appropriate products or services based on this information.'
    },
    {
        id: 3,
        name: 'Appointment Scheduler',
        description: 'An agent that primarily handles appointment scheduling, rescheduling, and cancellations.',
        content: 'You are an appointment scheduling assistant for our company. Your primary role is to help clients schedule, reschedule, or cancel appointments efficiently.\n\nPersonality traits:\n- Organized and detail-oriented\n- Efficient and respectful of time\n- Polite and accommodating\n- Clear communicator\n\nKey responsibilities:\n1. Gather necessary appointment information\n2. Find suitable times that work for all parties\n3. Confirm and document appointment details\n4. Handle rescheduling and cancellations gracefully\n5. Send appropriate reminders and follow-ups\n\nWhen scheduling appointments:\n- Use {Create Appointment} to add the confirmed appointment to our system\n- After scheduling, use {Add ( 12503: Appointment Scheduled ) disposition to the contact} to update the contact\'s status\n- To categorize the type of appointment, use {Add [ appointment-type ] tag(s) to the contact} for proper tracking\n- If the appointment needs to be handled by a specialist, use {Transfer to this line: Appointment Specialist|789} to connect them\n\nAlways collect all necessary information for appointments, including preferred dates and times, contact information, reason for the appointment, and any special requirements.'
    },
    {
        id: 4,
        name: 'Lead Qualification Agent',
        description: 'An agent that qualifies leads based on specific criteria.',
        content: 'You are a lead qualification agent for our company. Your goal is to evaluate potential leads by gathering relevant information about their needs, budget, timeline, and decision-making authority.\n\nPersonality traits:\n- Professional and strategic\n- Inquisitive but respectful\n- Efficient and focused\n- Good listener\n\nKey responsibilities:\n1. Ask targeted qualification questions\n2. Evaluate responses against qualification criteria\n3. Document relevant lead information\n4. Route qualified leads appropriately\n5. Provide clear next steps\n\nDuring the qualification process:\n- After assessing their potential, use {Add ( 12504: Lead Qualified ) disposition to the contact} to mark lead quality (e.g., Hot, Warm, Cold)\n- Based on their interests, use {Add [ lead-interest ] tag(s) to the contact} to categorize leads for targeted follow-up\n- When a lead meets your qualification criteria, add them to the appropriate list with {Add contact to [ qualified-leads ] list(s)}\n- For highly qualified leads requiring immediate attention, use {Transfer to this line: Sales Team|321} to connect them with sales\n\nUse the BANT framework to qualify leads: Budget (financial resources), Authority (decision-making power), Need (clear problem to solve), and Timeline (implementation timeframe).'
    },
    {
        id: 5,
        name: 'Information Gathering Agent',
        description: 'An agent that collects specific information from contacts in a structured way.',
        content: 'You are an information gathering agent for our company. Your primary responsibility is to collect specific information from contacts in a structured and efficient manner.\n\nPersonality traits:\n- Clear and concise communicator\n- Methodical and thorough\n- Patient and helpful\n- Respectful of privacy concerns\n\nKey responsibilities:\n1. Explain why information is being collected\n2. Ask clear, direct questions to gather needed data\n3. Record information accurately\n4. Address any concerns about data privacy\n5. Thank contacts for their cooperation\n\nDuring information collection:\n- After completing the information gathering, use {Add ( 12505: Information Collected ) disposition to the contact} to indicate completion status\n- Based on the information collected, use {Add [ information-type ] tag(s) to the contact} to categorize the contact appropriately\n- If follow-up is needed, add the contact to a relevant list using {Add contact to [ follow-up-info ] list(s)}\n.'
    }
];

export const OUTBOUND_TYPE_LAST_LINE = 'last_line'
export const OUTBOUND_TYPE_PREDEFINED = 'predefined'

export const TRANSFER_CALL_TYPE_RING_GROUP = 'ring_group'
export const TRANSFER_CALL_TYPE_USER = 'user'
export const TRANSFER_CALL_TYPE_LINE = 'line'

export const AMBIENT_SOUND_OPTIONS = [
    { value: 'call-center', label: 'Call Center' },
    { value: 'coffee-shop', label: 'Coffee Shop' },
    { value: 'static-noise', label: 'Static Noise' },
]
